import { IconsTypesProps } from './types';

export const MapArrowUpIcon = ({ fill, width, height }: IconsTypesProps) => (
  <svg
    style={{ width: `${width}px`, height: `${height}px` }}
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-sm="close-icon"
  >
    <path
      d="M1 7L7 0.999999L13 7"
      stroke="#7A4100"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
